export default __webpack_public_path__ + "static/media/google-maps.d1c430d2.svg";